import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';
import * as styles from './index.css';
import { clsx } from 'clsx';

type SparklesProps = {
  children: ReactNode;
  show: boolean;
  duration?: number;
  onHide?: () => void;
};
export const Sparkles = ({ children, show, duration = 10000, onHide }: SparklesProps) => {
  const timer = useRef<number>(-1);
  useEffect(() => {
    // If duration is 0, we don't want a timeout
    if (show && duration > 0) {
      timer.current = window.setTimeout(handleHide, duration);

      return () => {
        clearTimeout(timer.current);
      };
    }
  }, [show, duration]);

  const handleHide = () => {
    clearTimeout(timer.current);

    if (typeof onHide === 'function') {
      onHide();
    }
  };

  return (
    <div className={styles.wrapper} onMouseEnter={handleHide}>
      <div className={clsx(show ? null : styles.starWrapperFade)}>
        <svg className={clsx(styles.star, styles.star1)} viewBox="0 0 122.88 122.88" xmlns="http://www.w3.org/2000/svg">
          <path d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z" />
        </svg>
        <svg className={clsx(styles.star, styles.star2)} viewBox="0 0 122.88 122.88" xmlns="http://www.w3.org/2000/svg">
          <path d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z" />
        </svg>
        <svg className={clsx(styles.star, styles.star3)} viewBox="0 0 122.88 122.88" xmlns="http://www.w3.org/2000/svg">
          <path d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z" />
        </svg>
        <svg className={clsx(styles.star, styles.star4)} viewBox="0 0 122.88 122.88" xmlns="http://www.w3.org/2000/svg">
          <path d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z" />
        </svg>
        <svg className={clsx(styles.star, styles.star5)} viewBox="0 0 122.88 122.88" xmlns="http://www.w3.org/2000/svg">
          <path d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z" />
        </svg>
      </div>
      {children}
    </div>
  );
};
